import { Show, useTranslate } from "react-admin"
import InvoiceLayout from "../invoices/InvoiceLayout"
import InvoiceReminderShowActions from "./InvoiceReminderShowActions"

const InvoiceReminderShow = () => {
  const translate = useTranslate()
  
  return (
    <Show actions={<InvoiceReminderShowActions />} title={translate("resources.invoiceReminders.name", {smart_count: 1})}>
      <InvoiceLayout resource="invoiceReminders" isPreview={false} />
    </Show>
  )
}

export default InvoiceReminderShow